var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 30 31"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M28.344 1H1.656C.74 1 0 1.741 0 2.656v26.688C0 30.26.741 31 1.656 31h14.368V19.382h-3.91v-4.527h3.91v-3.34c0-3.874 2.367-5.984 5.823-5.984 1.656 0 3.08.123 3.494.178v4.05l-2.398.001c-1.88 0-2.244.893-2.244 2.204v2.89h4.484l-.584 4.528h-3.9V31h7.645C29.26 31 30 30.259 30 29.344V2.656C30 1.74 29.259 1 28.344 1"
})));
export default SvgFacebook;